import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { ClientContactsPage } from "@/modules/client-contacts/pages/ClientContactsPage";

export const Route = createFileRoute("/__authed/m/customers/contacts")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_clients")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: ClientContactsPage,
});
